import { Routes, Route, Navigate } from 'react-router-dom';
import { CardConfigPage } from './pages/CardConfigPage';
import { PublicCardPage } from './pages/PublicCardPage';
import { NotFoundPage } from './pages/NotFoundPage';
import ScannedCardsPage from './pages/ScannedCardsPage';
import { LandingPage } from './pages/LandingPage';

function App() {
  return (
    <div className="min-h-screen">
      <Routes>
        {/* Root route - landing page */}
        <Route path="/" element={<LandingPage />} />

        {/* Public routes - IMPORTANT: Must come after root and specific paths */}
        <Route path="/:slug" element={<PublicCardPage />} />

        {/* Config route (would be authenticated in production) */}
        <Route path="/config" element={<CardConfigPage />} />

        {/* Scanned cards management */}
        <Route path="/scanned" element={<ScannedCardsPage />} />

        {/* Fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
